var map = {
	"./symbol_0.png": 78956,
	"./symbol_1.png": 64405,
	"./symbol_2.png": 97054,
	"./symbol_3.png": 15367,
	"./symbol_4.png": 23848,
	"./symbol_5.png": 38065,
	"./symbol_6.png": 7898,
	"./symbol_7.png": 9123,
	"./symbol_8.png": 51460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 839;